import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgArrowForCheckInOut({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 40 19"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M30.67.07a1 1 0 01.7.3l8.32 8.3a1 1 0 010 1.42l-8.31 8.3a1 1 0 01-1.7-.7V11.2a1 1 0 01-.36.07H1a1 1 0 01-1-1v-1.8a1 1 0 011-1h28.32a1 1 0 01.35.07V1.07a1 1 0 011-1z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgArrowForCheckInOut.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgArrowForCheckInOut.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgArrowForCheckInOut svgRef={ref} {...props} />
));
export default ForwardRef;
